import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { createRoutine } from 'redux-saga-routines';
import { useInjectReducer, useInjectSaga } from 'utils/redux-injectors';
import { catalogSaga } from './saga';
import * as _ from 'lodash';
import {
  CatalogState,
  I_Ticket,
  I_PayloadGetTickets,
  I_FilterTicketDynamic,
  I_PayloadGetShows,
  I_Show,
  I_FilterShowDynamic,
} from './types';
export const GET_LIST_PAYMENT_METHOD = createRoutine(
  'catalog/getListPaymentMethod',
);
export const GET_LIST_TICKET_FORM = createRoutine('catalog/getTicketForm');
export const GET_TICKETS = createRoutine('catalog/getTickets');
export const GET_SHOWS = createRoutine('catalog/getShows');
export const GET_CATALOGS = createRoutine('catalog/getCatalogs');
export const GET_DETAIL_SHOW = createRoutine('catalog/getDetailShow');
export const GET_NEW = createRoutine('catalog/getNews');
export const GET_PROMOTION_PARK = createRoutine('catalog/getPromotionPark');
export const GET_PROMOTION = createRoutine('catalog/getPromotion');
export const RESET_NOT_FOUND = createRoutine('catalog/resetNotFound');

export const initialState: CatalogState = {
  loading: false,
  loadingPaymentMethod: false,
  error: false,
  success: false,
  optionsGetShows: {
    park: undefined,
    dateFrom: undefined,
    dateTo: undefined,
    date: undefined,
    time: undefined,
  },
  listFilterShowDynamic: {
    dates: [],
    times: [],
  },
  listShow: [],

  optionsGetTickets: {
    park: undefined,
    dateFrom: undefined,
    dateTo: undefined,
    show: undefined,
    dates: undefined,
    performances: undefined,
  },
  listFilterTicketDynamic: [],
  listTicket: [],
  listCatalog: [],
  listNew: [],
  listPromotionPark: [],
  listPromotion: [],
  paginatorPromotionPark: {},
  detailShow: undefined,
  paginator: {},
  getListShowSuccess: false,
  errorNotFound: null,
  listPaymentMethod: [],
  listTicketForm: [],
};

const slice = createSlice({
  name: 'catalog',
  initialState,
  reducers: {
    onsSetOptionsGetShows(state, action: PayloadAction<I_PayloadGetShows>) {
      const {
        park,
        dateFrom,
        dateTo,
        date,
        time,
        areaType,
        ageType,
        ticketType,
        catalog,
        limit,
        page,
        bpAllocatedDebt,
      } = action.payload;
      if (park !== undefined) state.optionsGetShows.park = park;
      if (dateFrom !== undefined) state.optionsGetShows.dateFrom = dateFrom;
      if (dateTo !== undefined) state.optionsGetShows.dateTo = dateTo;
      if (date !== undefined) state.optionsGetShows.date = date || undefined;
      if (time !== undefined) state.optionsGetShows.time = time || undefined;
      if (areaType !== undefined)
        state.optionsGetShows.areaType = areaType || undefined;
      if (ageType !== undefined)
        state.optionsGetShows.ageType = ageType || undefined;
      if (ticketType !== undefined)
        state.optionsGetShows.ticketType = ticketType || undefined;
      if (catalog !== undefined)
        state.optionsGetShows.catalog = catalog || undefined;
      if (limit !== undefined) state.optionsGetShows.limit = limit || 10;
      if (page !== undefined) state.optionsGetShows.page = page || 1;
      if (action.payload?.groupCode !== undefined) {
        state.optionsGetShows.groupCode = action.payload.groupCode;
      }
      if (action.payload?.numberChannel !== undefined) {
        state.optionsGetShows.numberChannel = action.payload.numberChannel;
      } else {
        delete state.optionsGetShows.numberChannel;
      }
      state.optionsGetShows.bpAllocatedDebt = bpAllocatedDebt;
    },
    onsSetOptionsGetTickets(state, action: PayloadAction<I_PayloadGetTickets>) {
      const { park, show, dateFrom, dateTo, dates, performances } =
        action.payload;
      if (park !== undefined) state.optionsGetTickets.park = park;
      if (show !== undefined) state.optionsGetTickets.show = show;
      if (dateFrom !== undefined) state.optionsGetTickets.dateFrom = dateFrom;
      if (dateTo !== undefined) state.optionsGetTickets.dateTo = dateTo;
      if (performances !== undefined)
        state.optionsGetTickets.performances = performances || undefined;
      if (dates !== undefined)
        state.optionsGetTickets.dates = dates || undefined;
    },
    setDetailShow(state, action: PayloadAction<I_Show | undefined>) {
      state.detailShow = action.payload;
    },
    resetDetailShowPage(state) {
      state.listFilterTicketDynamic = initialState.listFilterTicketDynamic;
      state.optionsGetTickets = initialState.optionsGetTickets;
      state.listTicket = initialState.listTicket;
      state.detailShow = initialState.detailShow;
      state.loading = initialState.loading;
      state.success = initialState.success;
      state.error = initialState.error;
    },
    resetStatusPage(state) {
      state.loading = initialState.loading;
      state.error = initialState.error;
      state.success = initialState.success;
    },
    setListShow(state, action: PayloadAction<I_Show[]>) {
      state.listShow = action.payload;
    },
  },
  extraReducers: {
    /**
     * ! GET SHOWS
     */
    [GET_SHOWS.TRIGGER]: (state, action: PayloadAction<I_PayloadGetShows>) => {
      state.loading = true;
      state.success = false;
      state.error = false;
      state.getListShowSuccess = false;
    },
    [GET_SHOWS.SUCCESS]: (
      state,
      action: PayloadAction<{
        shows: I_Show[];
        filters: I_FilterShowDynamic;
        paginator: any;
      }>,
    ) => {
      state.listShow = action.payload.shows;
      state.listFilterShowDynamic = action.payload.filters;
      state.paginator = action.payload.paginator;
      state.loading = false;
      state.getListShowSuccess = true;
      state.success = true;
      state.error = false;
    },
    [GET_SHOWS.FAILURE]: state => {
      state.loading = false;
      state.getListShowSuccess = false;
      state.success = false;
      state.error = true;
    },
    /**
     * ! GET DETAIL SHOW
     */
    [GET_DETAIL_SHOW.TRIGGER]: state => {
      state.detailShow = initialState.detailShow;
      state.loading = true;
      state.success = false;
      state.error = false;
    },
    [GET_DETAIL_SHOW.SUCCESS]: (state, action: PayloadAction<I_Show>) => {
      state.detailShow = action.payload;
      state.loading = false;
      state.success = true;
      state.error = false;
      state.errorNotFound = null;
    },
    [GET_DETAIL_SHOW.FAILURE]: (state, action) => {
      state.errorNotFound = action.payload;
      state.loading = false;
      state.success = false;
      state.error = true;
    },
    /**
     * ! GET TICKETS
     */
    [GET_TICKETS.TRIGGER]: (
      state,
      action: PayloadAction<I_PayloadGetTickets>,
    ) => {
      state.loading = true;
      state.success = false;
      state.error = false;
    },
    [GET_TICKETS.SUCCESS]: (
      state,
      action: PayloadAction<{
        tickets: I_Ticket[];
        filters: I_FilterTicketDynamic[];
      }>,
    ) => {
      state.listTicket = action.payload.tickets;
      state.listFilterTicketDynamic = action.payload.filters;
      state.loading = false;
      state.success = true;
      state.error = false;
    },
    [GET_TICKETS.FAILURE]: state => {
      state.loading = false;
      state.success = false;
      state.error = true;
    },
    /**
     * ! GET CATALOGS
     */
    [GET_CATALOGS.TRIGGER]: state => {
      state.loading = true;
      state.success = false;
      state.error = false;
    },
    [GET_CATALOGS.SUCCESS]: (state, action: any) => {
      state.listCatalog = action.payload;
      state.loading = false;
      state.success = true;
      state.error = false;
    },
    [GET_CATALOGS.FAILURE]: state => {
      state.loading = false;
      state.success = false;
      state.error = true;
    },
    /**
     * ! GET NEWS
     */
    [GET_NEW.TRIGGER]: state => {
      state.loading = true;
      state.success = false;
      state.error = false;
    },
    [GET_NEW.SUCCESS]: (state, action: any) => {
      state.listNew = action.payload;
      state.loading = false;
      state.success = true;
      state.error = false;
    },
    [GET_NEW.FAILURE]: state => {
      state.loading = false;
      state.success = false;
      state.error = true;
    },
    /**
     * ! GET_PROMOTION_PARK
     */
    [GET_PROMOTION_PARK.TRIGGER]: state => {
      state.loading = true;
      state.success = false;
      state.error = false;
    },
    [GET_PROMOTION_PARK.SUCCESS]: (state, action: any) => {
      state.listPromotionPark = action.payload.data;
      state.paginatorPromotionPark = action.payload.paginator;
      state.loading = false;
      state.success = true;
      state.error = false;
    },
    [GET_PROMOTION_PARK.FAILURE]: state => {
      state.loading = false;
      state.success = false;
      state.error = true;
    },
    /**
     * ! GET_PROMOTION_PARK
     */
    [GET_PROMOTION.TRIGGER]: state => {
      state.loading = true;
      state.success = false;
      state.error = false;
    },
    [GET_PROMOTION.SUCCESS]: (state, action: any) => {
      state.listPromotion = action.payload;
      state.loading = false;
      state.success = true;
      state.error = false;
    },
    [GET_PROMOTION.FAILURE]: state => {
      state.loading = false;
      state.success = false;
      state.error = true;
    },
    [RESET_NOT_FOUND]: (state, action) => {
      state.errorNotFound = null;
      state.loading = false;
      state.success = false;
      state.error = true;
    },
    /**
     * ! GET LIST PAYMENT METHOD
     */
    [GET_LIST_PAYMENT_METHOD.TRIGGER]: state => {
      state.loading = true;
      state.loadingPaymentMethod = true;
      state.success = false;
      state.error = false;
    },
    [GET_LIST_PAYMENT_METHOD.SUCCESS]: (state, action: PayloadAction<any>) => {
      state.listPaymentMethod = action.payload;
      state.loading = false;
      state.loadingPaymentMethod = false;
      state.success = true;
      state.error = false;
    },
    [GET_LIST_PAYMENT_METHOD.FAILURE]: state => {
      state.loading = false;
      state.loadingPaymentMethod = false;
      state.success = false;
      state.error = true;
    },
    /**
     * ! GET LIST TICKET FORM
     */
    [GET_LIST_TICKET_FORM.TRIGGER]: state => {
      state.loading = true;
      state.success = false;
      state.error = false;
    },
    [GET_LIST_TICKET_FORM.SUCCESS]: (state, action: PayloadAction<any>) => {
      state.listTicketForm = action.payload;
      state.loading = false;
      state.success = true;
      state.error = false;
    },
    [GET_LIST_TICKET_FORM.FAILURE]: state => {
      state.loading = false;
      state.success = false;
      state.error = true;
    },
  },
});

export const { actions: catalogActions } = slice;

export const useCatalogSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectSaga({ key: slice.name, saga: catalogSaga });
  return { actions: slice.actions };
};
